// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__R73Ww","col":"styles_col__2RzXR"};